var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8081 0.453147C11.8098 0.416332 11.8117 0.379844 11.8137 0.34375C11.812 0.380303 11.8101 0.416791 11.8081 0.453147C11.6363 4.20303 13.501 11.3842 22.375 10.9553C18.7503 11.2078 11.5674 13.7671 11.8129 21.9829C11.7002 18.3996 9.36622 11.3189 0.943187 11.2796C0.866865 11.2808 0.791988 11.2809 0.71875 11.2802C0.794022 11.2794 0.868834 11.2792 0.943187 11.2796C4.51877 11.2246 11.3382 9.01446 11.8081 0.453147Z",
    fill: "#19DEBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/Shape2.f667f5ff91ae35564fcc4dc3981291ec.svg";
export { ForwardRef as ReactComponent };